(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["toa-discovery-chips"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('toa-discovery')) {
    customElements.define('toa-discovery',class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound=true;
        this.addEventListener('click',event=>{
          const link=event.target.closest('a');
          if(!link || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const url=new URL(link.href);
          const facets=document.querySelector('facet-filters');
          if(url.origin!==location.origin || url.pathname!==location.pathname || typeof facets?.applyFilters!=='function') return;
          event.preventDefault();
          const preview=new URL(location.href).searchParams.get('preview_theme_id');
          if(preview) url.searchParams.set('preview_theme_id',preview);
          url.searchParams.delete('page');
          facets.applyFilters(url.searchParams.toString(),event);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
